import * as React from 'react';
import { observer } from 'mobx-react';

import { DataTableView, Column, ToolbarVisibility } from 'src/core/ui/data-table.view';
import { CardController } from 'src/app/shared/card.controller';
import { BrandEditorController } from 'src/app/general/brands/parts/brand-editor.controller';

interface Props extends ComponentViewProps<DataSet<AgentBrandItem>> {
	onCreateAgentBrand: () => Promise<AgentBrandItem>;
	mode: ControlMode;
}

@observer
export class AgentBrandView extends React.Component<Props, {}> {
	constructor(props: Readonly<Props>) {
		super(props);
	}

	columns: Column[] = [
		{
			key: 'displayName',
			dataIndex: 'displayName',
			title: 'Name',
			editable: (text: string, record: AgentBrandItem, index: number, isSelected: boolean) => {
				if (isSelected) {
					return (
						<BrandEditorController
							required
							label={null}
							mode={this.props.mode}
							setBusy={this.props.setBusy}
							value={record.brandId}
							onChanged={(item) => {
								record.brandId = item.id;
								record.brandName = item.name;
							}}
						/>
					);
				}

				return <span>{record.brandName}</span>;
			}
		}
	];

	render() {
		const { model, onCreateAgentBrand, mode, setBusy } = this.props;
		if (model == null) {
			return null;
		}

		return (
			<CardController
				title="Brands"
				icon="trademark"
				className="card-borderless"
				mode={this.props.mode}>
				<DataTableView
					model={model}
					mode={mode}
					setBusy={setBusy}
					columns={this.columns}
					createNewItem={onCreateAgentBrand}
					hideToolbar={ToolbarVisibility.hideSearch | ToolbarVisibility.hidePagination}
				/>
			</CardController>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/bookings/agent-brands/agent-brand.view.tsx